module.exports = vendor2_3e194ed8;